import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/**
 * AdminRoute - Protects admin-only routes
 * Redirects to /admin login page if user is not authenticated or not an admin
 */
const AdminRoute = ({ children }) => {
  const location = useLocation();
  const { user, isAdmin, loading } = useAuth();

  // Show loading state while checking authentication
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-600 mx-auto mb-4"></div>
          <p className="text.muted">Verifying access...</p>
        </div>
      </div>
    );
  }

  // Redirect to admin login if not authenticated or not an admin
  if (!user || !isAdmin) {
    return <Navigate to="/admin" replace state={{ reviewSearch: location.pathname === '/admin-panel' ? location.search : '' }} />;
  }

  // User is authenticated and is an admin - render the protected component
  return children;
};

export default AdminRoute;
